import { apiClient } from './client';
import type { Address, ApiResponse, City } from '../types';
import { formatCoord } from '../utils/utilityFunctions';

export const addressAPI = {

    async updateAddressCoordinates(
        addressId: number,
        coordinates: { latitude: number; longitude: number }
    ): Promise<ApiResponse<{
        message: string;
        coordinates: { latitude: number; longitude: number };
        saved_at: string;
    }>> {
        try {
            // coordinates.longitude &&= formatCoord(coordinates.longitude);
            // coordinates.latitude &&= formatCoord(coordinates.latitude);
            const response = await apiClient.post(
                `/addresses/${addressId}/update_coordinates/`,
                coordinates
            );
            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response?.data?.error || 'Failed to update coordinates',
                status: error.response?.status || 500,
            };
        }
    },

    async verifyAddress(addressId: number, approved: boolean, reason?: string): Promise<ApiResponse<any>> {
        try {
            const response = await apiClient.post(`/auth/addresses/${addressId}/verify-address/`, {
                approved,
                reason: reason || null
            });
            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response?.data?.detail || 'Failed to verify address',
                status: error.response?.status || 500
            };
        }
    },
    
      // Get all addresses for current user
      async getAddresses(): Promise<ApiResponse<Address[]>> {
        try {
          const response = await apiClient.get<Address[]>('/addresses/');
          return { data: response.data, status: response.status };
        } catch (error: any) {
          return {
            error: error.response?.data?.detail || 'Failed to fetch addresses',
            status: error.response?.status || 500,
          };
        }
      },
    
      // Get single address
      async getAddress(id: number): Promise<ApiResponse<Address>> {
        try {
          const response = await apiClient.get<Address>(`/addresses/${id}/`);
          return { data: response.data, status: response.status };
        } catch (error: any) {
          return {
            error: error.response?.data?.detail || 'Failed to fetch address',
            status: error.response?.status || 500,
          };
        }
      },
    
      // Add new address
      async addAddress(addressData: Partial<Address>): Promise<ApiResponse<Address>> {
        try {
          console.log('Sending address data:', JSON.stringify(addressData, null, 2));
    
          const response = await apiClient.post<Address>('/addresses/', addressData);
          return { data: response.data, status: response.status };
        } catch (error: any) {
          console.error('Full error:', error);
          console.error('Error response:', error.response?.data);
          return {
            error: error.response?.data || 'Failed to add address',
            status: error.response?.status || 500,
          };
        }
      },
    
      // async addAddress(addressData: Partial<Address>): Promise<ApiResponse<Address>> {
      //   try {
      //     const response = await apiClient.post<Address>('/addresses/', addressData);
      //     return { data: response.data, status: response.status };
      //   } catch (error: any) {
      //     return {
      //       error: error.response?.data?.detail || 'Failed to add address',
      //       status: error.response?.status || 500,
      //     };
      //   }
      // },
    
      // Update existing address
      async updateAddress(id: number, addressData: Partial<Address>): Promise<ApiResponse<Address>> {
        try {
          console.log('Sending address data:', JSON.stringify(addressData, null, 2));
          const response = await apiClient.put<Address>(`/addresses/${id}/`, addressData);
          return { data: response.data, status: response.status };
        } catch (error: any) {
          return {
            error: error.response?.data?.detail || 'Failed to update address',
            status: error.response?.status || 500,
          };
        }
      },
    
      // Delete address
      async deleteAddress(id: number): Promise<ApiResponse<void>> {
        try {
          const response = await apiClient.delete(`/addresses/${id}/`);
          return { data: undefined, status: response.status };
        } catch (error: any) {
          return {
            error: error.response?.data?.detail || 'Failed to delete address',
            status: error.response?.status || 500,
          };
        }
      },
    
      // Set address as default
      async setDefaultAddress(id: number): Promise<ApiResponse<Address>> {
        try {
          const response = await apiClient.patch<Address>(`/addresses/${id}/set_default/`);
          return { data: response.data, status: response.status };
        } catch (error: any) {
          return {
            error: error.response?.data?.detail || 'Failed to set default address',
            status: error.response?.status || 500,
          };
        }
      },
    
      // Get all cities (public endpoint)
      async getCities(): Promise<ApiResponse<City[]>> {
        try {
          const response = await apiClient.get<City[]>('/cities/');
          return { data: response.data, status: response.status };
        } catch (error: any) {
          return {
            error: error.response?.data?.detail || 'Failed to fetch cities',
            status: error.response?.status || 500,
          };
        }
      },
};

export default addressAPI;